<form autocomplete="off" class="p-0" novalidate enctype="multipart/form-data" [formGroup]="qualificationDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-3">
            <div>
                <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/knowledge.png"
                            class="mh-45px mrl mt-1 pb-2">
                        Qualification Details</b></h3>
            </div>
            <div class="row clearfix" *ngIf="QualifyShow">
                <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuCoLvl'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuCoLvl'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuCoLvl'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select10441 class="colorblack" formControlName="StuCoLvl">
                                <mat-select-filter *ngIf="select10441.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdDesc'" [array]="courseLevelList"
                                    (filteredReturn)="filteredcourseLevelList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredcourseLevelList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuCoLvl'].touched && qualificationDetailsForm.controls['StuCoLvl'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuCoName'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuCoName'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuCoName'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select1044 class="colorblack" formControlName="StuCoName">
                                <mat-select-filter *ngIf="select1044.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdDesc'" [array]="courseList"
                                    (filteredReturn)="filteredcourseList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredcourseList" [value]="item.CdCode">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuCoName'].touched && qualificationDetailsForm.controls['StuCoName'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuQualStr'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuQualStr'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuQualStr'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select [disabled]="delReadOnly" formControlName="StuQualStr" #select104
                                placeholder="Status" class="colorblack">
                                <mat-option [value]="1" (click)="onSelectionChangedForDecResu(1)">Declared</mat-option>
                                <mat-option [value]="2" (click)="onSelectionChangedForDecResu(2)">Not
                                    Declared</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuQualStr'].touched && qualificationDetailsForm.controls['StuQualStr'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-sm-3" *ngIf="qualificationDetailsFormArray['StuUniversity'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuUniversity'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuUniversity'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select1054 class="colorblack" formControlName="StuUniversity">
                                <mat-select-filter *ngIf="select1054.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdDesc'" [array]="boardUniList"
                                    (filteredReturn)="filteredboardUniList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredboardUniList" [value]="item.CdCode"
                                    (click)="otherUniversity(item)">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuUniversity'].touched && qualificationDetailsForm.controls['StuUniversity'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-4" *ngIf="showotheruni">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>
                                    University Name
                                </mat-label>
                                <input [readonly]="delReadOnly" maxlength="500" formControlName="otherUni" matInput
                                    placeholder="Name">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4" *ngIf="qualificationDetailsFormArray['StuClgName'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuClgName'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuClgName'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" maxlength="500" formControlName="StuClgName" matInput
                                    placeholder="Name">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuClgName'].touched && qualificationDetailsForm.controls['StuClgName'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuClgName'].touched && qualificationDetailsForm.controls['StuClgName'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuPassYr'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuPassYr'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuPassYr'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select1044 [disabled]="resultNotDec" class="colorblack"
                                    formControlName="StuPassYr">
                                    <mat-select-filter *ngIf="select1044.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="PassYearList"
                                        (filteredReturn)="filteredPassYearList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredPassYearList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPassYr'].touched && qualificationDetailsForm.controls['StuPassYr'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuMarkListRgNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- [readonly]="delReadOnly || resultNotDec"  -->
                                <input formControlName="StuMarkListRgNo" matInput placeholder="Registration No"
                                    maxlength="20">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarkListRgNo'].touched && qualificationDetailsForm.controls['StuMarkListRgNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarkListRgNo'].touched && qualificationDetailsForm.controls['StuMarkListRgNo'].errors?.pattern">
                                    Enter Valid Data.
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuSeatNo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuSeatNo'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuSeatNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuSeatNo" matInput
                                    placeholder="Seat Number" maxlength="10">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuSeatNo'].touched && qualificationDetailsForm.controls['StuSeatNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuSeatNo'].touched && qualificationDetailsForm.controls['StuSeatNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuMarksTot'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMarksTot'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuMarksTot'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly || resultNotDec" formControlName="StuMarksTot" matInput
                                    placeholder="Marks" maxlength="5" (change)="percentage()">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksTot'].touched && qualificationDetailsForm.controls['StuMarksTot'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksTot'].touched && qualificationDetailsForm.controls['StuMarksTot'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuMarksObt'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuMarksObt'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuMarksObt'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly || resultNotDec" formControlName="StuMarksObt" matInput
                                    placeholder="Marks" maxlength="5" (change)="percentage()">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksObt'].touched && qualificationDetailsForm.controls['StuMarksObt'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuMarksObt'].touched && qualificationDetailsForm.controls['StuMarksObt'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>

                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuPercent'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuPercent'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="qualificationDetailsFormArray['StuPercent'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input readonly formControlName="StuPercent" maxlength="5" matInput placeholder="Marks">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPercent'].touched && qualificationDetailsForm.controls['StuPercent'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuGrade'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuGrade'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuGrade'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="delReadOnly" formControlName="StuGrade" #select104
                                    class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option value="1">A</mat-option>
                                    <mat-option value="2">A+</mat-option>
                                    <mat-option value="3">B</mat-option>
                                    <mat-option value="4">B+</mat-option>
                                    <mat-option value="5">C</mat-option>
                                    <mat-option value="6">D</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuGrade'].touched && qualificationDetailsForm.controls['StuGrade'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuCgpi'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuCgpi'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuCgpi'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly || resultNotDec" formControlName="StuCgpi" matInput
                                    placeholder="CGPI" maxlength="3">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCgpi'].touched && qualificationDetailsForm.controls['StuCgpi'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuCgpi'].touched && qualificationDetailsForm.controls['StuCgpi'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-4"></div> -->
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuClass'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{qualificationDetailsFormArray['StuClass'][0]['FormDisplayName']}}
                                <span *ngIf="qualificationDetailsFormArray['StuClass'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select [disabled]="delReadOnly || resultNotDec" formControlName="StuClass" #select104
                                placeholder="Type" class="colorblack">
                                <mat-option>Select</mat-option>
                                <mat-option value="1">Distinction</mat-option>
                                <mat-option value="2">First Class</mat-option>
                                <mat-option value="3">Second Class</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="qualificationDetailsForm.controls['StuClass'].touched && qualificationDetailsForm.controls['StuClass'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>

                    </div>
                </div>
                <div class="col-sm-2" *ngIf="qualificationDetailsFormArray['StuPlace'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{qualificationDetailsFormArray['StuPlace'][0]['FormDisplayName']}}
                                    <span *ngIf="qualificationDetailsFormArray['StuPlace'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="delReadOnly" formControlName="StuPlace" matInput placeholder="Place"
                                    maxlength="100">
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPlace'].touched && qualificationDetailsForm.controls['StuPlace'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="qualificationDetailsForm.controls['StuPlace'].touched && qualificationDetailsForm.controls['StuPlace'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-12 btnpossition"
                    *ngIf="qualificationDetailsFormArray['fileUploadData'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="col-sm-6">
                            <mat-label>{{qualificationDetailsFormArray['fileUploadData'][0]['FormDisplayName']}}
                                <span
                                    *ngIf="qualificationDetailsFormArray['fileUploadData'][0]['FormRequired']">*</span>
                            </mat-label>
                        </div>
                        <input #fileUploader type="file" formControlName="fileUploadData" (change)="onChange($event)" />

                        <div *ngIf="filename; else noFileUploaded" (click)="showbaseFile()">
                            <p class="file-name">
                                Uploaded File: <span class="blue_col">{{ filename }}</span>
                            </p>
                        </div>
                        <ng-template #noFileUploaded>
                            <p *ngIf="!filename && prepopulateDataAvailable">File Not Uploaded</p>
                        </ng-template>
                        <mat-error class="margin_tp"
                            *ngIf="qualificationDetailsForm.controls['fileUploadData'].touched && qualificationDetailsForm.controls['fileUploadData'].errors?.required">
                            Mandatory
                        </mat-error>
                    </div>

                </div>
                <div class="col-sm-12">
                    <div class="form-group redCol">
                        <h6 class="mb-1 redCol"><b>
                                Note 1: Please upload file less than 3 MB. Please upload
                                only png, jpg, jpeg or pdf file.</b></h6>
                        <h6 class="mb-1 redCol"><b>
                                Note 2: Kindly enter correct obtained marks, total marks and percentage as per
                                marksheet,
                                merit will be generated on the basis of percentage.</b></h6>
                        <h6 class="mb-1 redCol"><b>
                                Note 3: In case student have multiple marksheet then zip it and upload it year wise.</b>
                        </h6>

                    </div>
                </div>
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="submitButton" [disabled]="isSaving"
                            (click)="SubmitQualificationDetails()"
                            class="btn btn-primary btn-icon-text floatright sz fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled"
                            (click)="UpdateQualificationDetails()"
                            class="btn btn-primary btn-icon-text floatright sz fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" *ngIf="deleteButton" [disabled]="disabled"
                            (click)="openConformationModalBox()"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/trash.gif" style="margin-right: 5px;">
                                Delete
                            </span>
                        </button>
                        <button type="button" *ngIf="resetButton" [disabled]="disabled" (click)="resetForm()"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/add-file.gif" style="margin-right: 5px;">
                                New
                            </span>
                        </button>

                        <button type="button" *ngIf="nextButton" (click)="nextTab()"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-right.gif" style="margin-right: 5px;">
                                Next
                            </span>
                        </button>
                        <button type="button" (click)="back()"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
                <hr *ngIf="isDivShow==true">
                <div class="table-responsive" id="table">
                    <table id="datatable" class="table table-bordered text-nowrap">
                        <thead>
                            <tr *ngIf="isDivShow==true" class="text-left">

                                <th class="f600">
                                    No.
                                </th>
                                <th class="f600 text-left">
                                    Board / University
                                </th>
                                <th class="f600">
                                    College / School
                                </th>
                                <th class="f600">
                                    Course
                                </th>
                                <th class="f600">
                                    Pass Year
                                </th>
                                <th width="7%">
                                    Obt Marks
                                </th>
                                <th width="7%">
                                    Tot Marks
                                </th>
                                <th width="7%">
                                    Percent
                                </th>
                                <th width="7%">
                                    Document
                                </th>
                                <th width="5%">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody id="table_data">
                            <tr *ngFor="let data of qualList; let i = index" class="text-left">

                                <td>{{i + 1}}</td>
                                <td>{{data.CdDesc}}</td>
                                <td> {{data.StuClgName}}</td>
                                <td> {{data.StuCourseName}}</td>
                                <td>{{data.StuPassYr}}</td>
                                <td>{{data.StuMarksObt}}</td>
                                <td>{{data.StuMarksTot}}</td>
                                <td>{{data.StuPercent}}</td>
                                <td class="text-center" (click)="showbase64(data)">
                                    <a><label class="blue_col">View</label></a>
                                </td>
                                <td class="text-center">
                                    <a class="btn-floating" (click)="onselectPrepopulate(data)" title="Prepopulate">
                                        <i class="fa fa-eye" aria-hidden="false"></i>
                                    </a>
                                    <a class="btn-floating" title="Delete" (click)="onselectPrepopulateForDelete(data)">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</form>